import type { NotificationCategory } from '@allemnii-pulse/shared';

export const NOTIFICATION_CATEGORY_LABEL: Record<NotificationCategory, string> = {
  blocker_raised: 'Blocker raised on a task you lead',
  task_assigned: 'Task assigned to you',
  comment_mention: 'Someone mentions you in a comment',
  task_blocked: 'A task you own moves to Blocked',
  task_ready_for_testing: 'A task is ready for you to test',
  document_pending_validation: 'A document is pending validation',
  regeneration_proposals: 'Regeneration proposals awaiting review',
  discussion_mention: 'Someone tags you in a project discussion',
};

/** Notification `link` values are in-app routes like "/projects/{id}/tasks/{id}" (see the
 * notify() call sites in apps/api/src/routes) — used to group the notification panel by
 * project, the same shape docs/PLAN.md §7.3 asks for. */
export function projectIdFromLink(link: string | null | undefined): string | null {
  if (!link) return null;
  const [, root, projectId] = link.split('/');
  return root === 'projects' ? (projectId ?? null) : null;
}
